<template>
  <div class="content new-order form">
    <div class="row">
      <div class="col-sm-12 description-line">
        <div class="row description col-sm-12">
          <div class="col-sm-3">
            <span>Advertiser: </span><label>Sa Sa Dot Com Limited</label>
          </div>
          <div class="col-sm-3">
            <span>Product: </span><label>SKII Innovation Cream</label>
          </div>
          <div class="col-sm-2"><span>Status: </span><label>-</label></div>
          <div class="col-sm-2">
            <span>Create By: </span><label>Steven Cheung</label>
          </div>
          <div class="col-sm-2">
            <span>Date: </span><label>15/03/2022</label>
          </div>

          <div class="col-sm-3">
            <span>Contracting Party: </span><label>Sa Sa Dot Com Limited</label>
          </div>
          <div class="col-sm-3">
            <span>Order No.: </span><label>PS10000001</label>
          </div>
          <div class="col-sm-2">
            <span>Contract No.: </span><label>-</label>
          </div>
          <div class="col-sm-2">
            <span>Updated By: </span><label>Steven Cheung</label>
          </div>
          <div class="col-sm-2">
            <span>Date: </span><label>15/03/2022</label>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <el-card>
        <el-tabs
          v-model="activeName"
          @tab-click="operationInstructionsTabClick"
        >
          <el-tab-pane label="Contract Info" name="first">
            <contract-setting></contract-setting>
          </el-tab-pane>
          <el-tab-pane label="Media Items" name="second">
            <media-item></media-item>
          </el-tab-pane>
          <el-tab-pane label="Internal Split" name="third">
            <internal-split></internal-split>
          </el-tab-pane>
          <el-tab-pane label="Operation Instructions" name="fourth">
            <operation-instruction></operation-instruction>
          </el-tab-pane>
          <el-tab-pane label="Payment Schedule" name="fivth">
            <payment-schedule></payment-schedule>
          </el-tab-pane>
          <el-tab-pane label="Draft Contract" name="sixty">
            <draft-contract></draft-contract>
          </el-tab-pane>
        </el-tabs>
      </el-card>

      <div style="display: flex; justify-content: space-between; width: 100%">
        <base-button
          :style="{ visibility: isDraftContractTab ? 'visible' : 'hidden' }"
          >PDF</base-button
        >
        <div style="display: flex; column-gap: 5px">
          <base-button @click="saveEditAddress(editAddressForm.index)"
            >Back</base-button
          >
          <base-button
            type="primary"
            @click="saveEditAddress(editAddressForm.index)"
            >Revise</base-button
          >
          <base-button
            type="primary"
            @click="saveEditAddress(editAddressForm.index)"
            >Submit</base-button
          >
          <base-button @click="mediaSelectDialogShow = false"
            >Close</base-button
          >
        </div>
      </div>
    </div>

    <el-dialog
      title="New Payment Schedule"
      :visible.sync="newPaymentScheduleDialogShow"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="row">
        <div class="col-sm-4">
          <div style="padding: 10px; background-color: #fafbfc">
            <div style="margin-right: 25px; line-height: 32px">Information</div>
            <div style="display: flex">
              <base-input label="Description" style="width: 100%"> </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div style="padding: 10px; background-color: #fafbfc">
            <div style="margin-right: 25px; line-height: 32px">
              Schedule Setting
            </div>
            <div style="display: flex">
              <base-input label="Type" style="width: 100%"> </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div style="padding: 10px; background-color: #fafbfc">
            <div style="margin-right: 25px; line-height: 32px">Terms</div>
            <div style="display: flex">
              <base-input label="Payment Term" style="width: 100%">
              </base-input>
            </div>
            <div style="display: flex">
              <base-input label="Invoice Term" style="width: 100%">
              </base-input>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <base-button>Regenerate</base-button>
        <base-button type="primary">Regroup</base-button>
      </div>
    </el-dialog>
  </div>
</template>
<script setup>
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import baseRadio from '@/components/newUI/Inputs/BaseRadio';
import contractSetting from '@/views/newUI/view/ContractSetting';
import mediaItem from '@/views/newUI/view/MediaItem';
import internalSplit from '@/views/newUI/view/InternalSplit';
import operationInstruction from '@/views/newUI/view/OperationInstruction';
import paymentSchedule from '@/views/newUI/view/PaymentSchedule';
import draftContract from '@/views/newUI/view/DraftContract';
import { nextTick, ref } from 'vue';

const demoList = [
  {
    bonus: true,
    price_option: '8 Weeks Standard',
    rate_option: '8 Weeks',
    unity_qty: '1',
    gross_rate_w_cpm: '$50,000.00',
    qty_imp: '30',
    tbc: false,
    campagin_period: '01/02/2023 - 14/02/2023',
    days: '14',
    gross_item_sum: '$375,000.00',
  },
];

const demoList2 = [
  {
    firstCol: false,
    bonus: true,
    tbc: false,
    startDate: '01/02/2023',
    endDate: '14/02/2023',
    days: 14,
    qty: 20,
    postDateType: 'Any Time',
    postingStartFrom: '',
    depostDateType: 'After Campaign Period',
    depostDate: '',
    remark: '',
  },
];

const demoList3 = [
  {
    transferFromContractNo: '',
    transferToContractNo: '',
    transferInOut: '',
    mediaSeq: 1,
    productionDate: '10/10/2022',
    productionCostType: 'Both',
    remark: '',
    unitPriceBySalesAdmin: '$0',
    updateBy: 'xxxxxxxxxxx',
    updateDate: '17/10/2022',
  },
];

const demoList4 = [
  {
    bonus: false,
    tbc: false,
    period: { start: '', end: '' },
    days: 14,
    qry_imp: 30,
    gross_rate_w_cpm: '$50,000.00',
    loading: 0.1,
    gross_item_sum: '$375,375.00',
    net_item_sum: '$8,592.27',
    unit_prod_cost: '$0.1',
    total_prod_cost: '$3.00',
    media_total_int_split: '$8,592.27',
    prod_total_int_split: '$3',
    service_fee: '$0',
  },
];

var activeName = 'first';
var mediaSelectDialogShow = ref(false);
var selectedCity = ['xxxxx'];
var selectedLocation = ['kmb', 'lwb'];
var selectedFormat = ['xxx', 'xxxxx'];
var selectedMedia = ['MDA75942', 'MDA75888'];
var showOperationInstruction = ref(false);
var showInternalSplit = ref(false);
var isDraftContractTab = ref(false);
var newPaymentScheduleDialogShow = ref(false);

const newContract = () => {
  console.log('new Order');
  this.$router.push({ name: 'New Order', query: { psid: '' } });
};
const showMediaSelectDialog = async () => {
  mediaSelectDialogShow.value = true;
  await nextTick();
};
const operationInstructionsTabClick = async (e, val) => {
  console.log(e.props.label);
  showOperationInstruction.value = e.props.label == 'Operation Instructions';
  showInternalSplit.value = e.props.label == 'Internal Split';
  console.log(showInternalSplit);

  isDraftContractTab.value = e.props.label == 'Draft Contract';
  await nextTick();
};
const addPaymentSchedule = () => {
  this.newPaymentScheduleDialogShow = true;
};

const saveEditAddress = () => {
  console.log('test');
};

// export default {
//   computed: {

//   },
//   data() {
//     return {
//       clientType:'',
//       isNewClient:false,
//       demoList: [{
//         bonus: true,
//         price_option: '8 Weeks Standard',
//         rate_option: '8 Weeks',
//         unity_qty: '1',
//         gross_rate_w_cpm: '$50,000.00',
//         qty_imp: '30',
//         tbc: false,
//         campagin_period: '01/02/2023 - 14/02/2023',
//         days: '14',
//         gross_item_sum: '$375,000.00',
//        }],
//       demoList2: [{
//         firstCol: false,
//         bonus: true,
//         tbc: false,
//         startDate: '01/02/2023',
//         endDate: '14/02/2023',
//         days: 14,
//         qty: 20,
//         postDateType: 'Any Time',
//         postingStartFrom: '',
//         depostDateType: 'After Campaign Period',
//         depostDate: '',
//         remark: ''
//        }],
//       demoList3: [{
//         transferFromContractNo: '',
//         transferToContractNo: '',
//         transferInOut: '',
//         mediaSeq: 1,
//         productionDate: '10/10/2022',
//         productionCostType: 'Both',
//         remark: '',
//         unitPriceBySalesAdmin: '$0',
//         updateBy: 'xxxxxxxxxxx',
//         updateDate: '17/10/2022'
//        }],
//        demoList4: [{
//         bonus: false,
//         tbc: false,
//         period: { start:'', end: '' },
//         days: 14,
//         qry_imp: 30,
//         gross_rate_w_cpm: '$50,000.00',
//         loading: 0.1,
//         gross_item_sum: '$375,375.00',
//         net_item_sum: '$8,592.27',
//         unit_prod_cost: '$0.1',
//         total_prod_cost: '$3.00',
//         media_total_int_split: '$8,592.27',
//         prod_total_int_split: '$3',
//         service_fee: '$0'
//        }],

//        activeName: 'first',
//         mediaSelectDialogShow: false,
//         selectedCity: ['xxxxx'],
//        selectedLocation:['kmb', 'lwb'],
//        selectedFormat: ['xxx', 'xxxxx'],
//        selectedMedia:['MDA75942','MDA75888'],
//        showOperationInstruction: false,
//        showInternalSplit: false ,
//        isDraftContractTab: false,
//        newPaymentScheduleDialogShow: false
//     };
//   },
//   methods: {
//     newContract(){
//         console.log('new Order');
//         this.$router.push({ name: 'New Order', query: { psid: '' } })
//     },
//     showMediaSelectDialog() {
//         this.mediaSelectDialogShow = true
//     },
//     operationInstructionsTabClick(e) {
//         this.showOperationInstruction = (e.label == "Operation Instructions")
//         this.showInternalSplit = (e.label == "Internal Split")

//         this.isDraftContractTab = (e.label == "Draft Contract")
//     },
//     addPaymentSchedule() {
//         this.newPaymentScheduleDialogShow = true;
//     }
//   },
//   mounted() {

//   },
//   watch: {
//     /**
//      * Searches through the table data by a given query.
//      * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
//      * @param value of the query
//      */
//     // searchQuery(value) {
//     //   let result = this.tableData;
//     //   if (value !== '') {
//     //     result = this.fuseSearch.search(this.searchQuery);
//     //   }
//     //   this.searchedData = result;
//     // }
//   }
// };
</script>

<style scope>
.new-order h4 {
  color: #3b291d;
}
.new-order h5 {
  color: #423022;
}
.sales-title h4.sub {
  margin-left: 54px;
  display: inline-block;
  font-size: 11px;
}
.sales-title i {
  position: relative;
  top: -1px;
  right: 4px;
}

.new-order .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 6px;
}

/* .advertiser-field .form-group.has-label label::after{
    content:'【 Contracting Party 】';
    color:#d05c5f;
} */
.sub-info {
  font-size: 10px;
  color: #9a9a9a;
  margin-left: 30px;
}
.sub-info .dot {
  width: 5px;
  height: 5px;
  background-color: rgb(169, 169, 169);
  display: inline-block;
  border-radius: 50%;
  top: -1px;
  position: relative;
  right: 2px;
}

.newRow {
  padding-bottom: 25px;
  padding-top: 25px;
}

.company-entity-field .form-group.has-label label::after {
  content: '【 Production 】';
  color: #d05c5f;
}

.Rectangle {
  width: 130px;
  height: 32px;
  text-align: center;
  border-radius: 6px;
  border: solid 1px #543d2c;
}

.newCard {
  padding: 7px 11px 11.5px;
  border-radius: 6px;
  border: solid 1px #543d2c;
  margin-bottom: 25px;
}

.newCardNoPadding {
  border-radius: 6px;
  border: solid 1px #543d2c;
  margin-bottom: 25px;
  padding-bottom: 10px;
}

.newText {
  opacity: 0.8;
  font-family: Poppins;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.93;
  letter-spacing: normal;
  text-align: left;
  color: #423022;
}

/* .groupButtonBus {
    border-top-left-radius: 5px;
 border-bottom-left-radius: 5px;
  border: solid px #eb6100;
   width: 107px;
  height: 38px;

line-height: 38px;
  background-image: linear-gradient(to top, #eb6100, #b60005);
  text-align: center;
  color: #fff
} */

/* .groupButtonOutdoor,
.groupButtonMtr {
  border: solid 1px #eb6100;
  width: 107px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  color: #eb6100;
} */
.groupButtonMtr {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.RectangleNoWidth {
  line-height: 38px;
  height: 38px;
  text-align: left;
  border-radius: 6px;
  border: solid 1px #e3e3e3;
  background-color: #f5f5f5;
}

.tableRectangle {
  border: solid 1px #e3e3e3;
  padding: 10px;
  height: 90px;
}

table.internal-split {
  width: 100%;
}

table.internal-split td {
  border: 1px solid #e3e3e3;
  padding: 10px 15px;
}

.el-date-editor {
  margin-top: 0px !important;
}
</style>
